import type { Tool } from './types';

export const aiAstrologer: Tool = {
  slug: 'ai-astrologer',
  metaTitle: 'Talk to an AI Astrologer Online — Free AI Vedic Astrology Chat',
  metaDescription:
    'Chat with a free AI astrologer online, 24/7. Ask about career, marriage, health and timing — answered from your own Vedic birth chart using classical Jyotish, in plain language.',
  keywords:
    'ai astrologer, talk to ai astrologer, ai astrology chat, ai vedic astrology, ai jyotish, free ai astrologer online, chat with astrologer',
  eyebrow: 'AI Vedic Astrologer',
  h1: 'Talk to an AI Astrologer Online, Free',
  appName: 'KundaliAI AI Astrologer',
  intro:
    'Ask an AI Vedic astrologer anything — career, marriage, money, health or timing — and get answers grounded in your own birth chart, 24/7, in plain language. KundaliAI reads your Kundali the way a seasoned Jyotishi would, using classical Vedic rules. Free to start, no appointment needed.',
  ctaLabel: 'Start chatting free',
  ctaHref: '/chat',
  sections: [
    {
      heading: 'A real astrologer conversation, on demand',
      body: "Instead of a generic horoscope, KundaliAI answers *your* questions from *your* chart. Ask *'when will I get a job?'*, *'is this a good year for marriage?'* or *'which Dasha am I running?'* and get a specific, chart-grounded answer — then keep asking follow-ups. No waiting rooms, no per-minute call charges, available any time of day.",
    },
    {
      heading: 'Grounded in classical Jyotish',
      body: 'The AI builds your birth chart from precise astronomical positions and reasons over the real placements — houses, planetary lords, aspects, Nakshatras and Dasha periods — applying traditional Vedic astrology principles. It explains its reasoning in everyday language so you understand *why*, not just *what*.',
    },
    {
      heading: 'What you can ask about',
      body: 'People use KundaliAI for:\n\n- **Career & finance** — job timing, business, wealth yogas.\n- **Marriage & relationships** — timing, compatibility, Mangal Dosha.\n- **Health & wellbeing** — chart indications and cautious periods.\n- **Dasha & transits** — what the current planetary period means for you.\n- **Remedies** — traditional measures suited to your chart.',
    },
    {
      heading: 'How KundaliAI compares',
      body: 'Many AI astrology chatbots give surface-level answers. KundaliAI stays anchored to your actual chart across a conversation, checks the classical conditions (like dosha cancellations) that simple tools miss, and is free to start. Bring your birth details and see the difference.',
    },
  ],
  faq: [
    {
      question: 'Is the AI astrologer free?',
      answer:
        'Yes — you can start a conversation and ask questions for free, without an account. Premium plans unlock unlimited questions, saved charts and detailed reports.',
    },
    {
      question: 'How is this different from a normal horoscope?',
      answer:
        'A daily horoscope is generic to your sun or moon sign. KundaliAI answers from your full birth chart and responds to your specific questions in a back-and-forth conversation.',
    },
    {
      question: 'Is AI astrology accurate?',
      answer:
        'The chart is computed from precise astronomical data, and the interpretation applies classical Jyotish rules. AI makes that expertise instant and conversational, though it is intended for guidance and reflection, not as a substitute for professional advice.',
    },
    {
      question: 'Do I need to create an account?',
      answer:
        'No — you can begin chatting for free right away. Creating a free account lets you save your chart and history.',
    },
  ],
  related: [
    { label: 'Free Kundli by date of birth', href: '/free-kundli' },
    { label: 'Kundli matching by AI', href: '/kundli-matching' },
    { label: 'Mangal Dosha calculator', href: '/mangal-dosha-calculator' },
  ],
};
